<div class="row">
  @if (label) {
    <div [ngClass]="{'col-md-4': !bigInput, 'col-md-2': bigInput}">
      <label>{{endingCharacter(label)}}</label>
    </div>
  }
  <div [ngClass]="{'col-md-12': !label, 'col-md-8': label && !bigInput, 'col-md-10': label && bigInput}">
    @if (buttonValuesString !== undefined) {
      <mat-radio-group class="radioButtonGroup" [(ngModel)]="value" [labelPosition]="labelPosition"
        [required]="mandatory"   [disabled]="!editable || fieldLevelSecurity === 'I' || fieldLevelSecurity === 'N'"
                     [ngClass]="{'fullWidth': !isButtonDisplayed,
                                'inputErrorBackground': validatorMessages.length > 0,
                                 'tableInput': tableInput}">
        @for (button of buttonValuesString; track button) {
          <mat-radio-button class="radioButtonSpacing" [value]="button[0]" (click)="onSelct()">{{endingCharacter(button[1])}}</mat-radio-button>
        }
      </mat-radio-group>
    }
    @if (buttonValuesBoolean !== undefined) {
      <mat-radio-group class="radioButtonGroup" [(ngModel)]="value" [labelPosition]="labelPosition"
        [required]="mandatory"  [disabled]="!editable || fieldLevelSecurity === 'I' || fieldLevelSecurity === 'N'">
        @for (button of buttonValuesBoolean; track button) {
          <mat-radio-button class="radioButtonSpacing" [value]="button[0]">{{endingCharacter(button[1])}}</mat-radio-button>
        }
      </mat-radio-group>
    }
    @for (message of validatorMessages; track message) {
      <div class="inputValidationMessage" [ngClass]="{'inputValidationMessageTable' : tableInput}">
        {{message}}
      </div>
    }

  </div>

</div>
